import { LEGAL_PAGES } from "../data/content";
import { MaskedLine, Reveal } from "../components/Reveal";

const Legal = ({ page }) => {
  const content = LEGAL_PAGES[page];
  return (
    <main data-testid={`rnb-legal-${page}`} className="bg-[#050505] pt-40 pb-24 min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <MaskedLine delay={0.1}>
          <span className="text-xs tracking-[0.4em] text-zinc-500 uppercase">Legal</span>
        </MaskedLine>
        <h1 className="mt-4 font-display text-rough text-white leading-[0.9] text-5xl sm:text-7xl">
          <MaskedLine delay={0.2}>{content.title}</MaskedLine>
        </h1>
        <div className="mt-12 space-y-10">
          {content.sections.map((s, i) => (
            <Reveal key={s.h} delay={0.1 + i * 0.05}>
              <h2 className="font-display text-2xl tracking-wide text-white">{s.h}</h2>
              <p className="mt-3 text-sm sm:text-base text-zinc-400 font-light leading-relaxed">{s.p}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3} className="mt-14">
          <p className="text-xs text-zinc-600 leading-relaxed">
            Última actualización: julio de 2026. Para cualquier duda sobre este documento, escribe a info@rnbcoaching.com.
          </p>
        </Reveal>
      </div>
    </main>
  );
};

export default Legal;
